<template>
  <div class="img_wrapper">
    <div class="trip_info">
      <div class="trip_title">建议：</div>
      <div class="trip_con">
        <!-- <p>图片尺寸：686px*370px，大小：&lt;350KB；视频格式：.mp4,大小:&lt;150M。</p> -->
        <p>图片尺寸：990px*350px，大小：&lt;350KB；视频格式：.mp4,大小:&lt;150M。</p>
      </div>
    </div>
    <div class="imgInfro">视频</div>
    <div class="ImgBP">
      <div class="item_img">
        <div class="editimg"></div>
        <upload-file-list-cmp sk-type="1" :f-list="videoList" class="file-upload" type="video" @fileListUrlFn="fileListUrlFn"></upload-file-list-cmp><!-- -->
      </div>
    </div>

    <div class="imgInfro">本铺</div>
    <div class="ImgBP">
      <div class="item_img">
        <div class="editimg"></div>
        <div class="imgList_cmp">
          <div class="img_content glj-upload-list-item-info" v-for="(item,index) in thisShopList" :key="index" >
            <img style="width: 100px;  margin-top: 10px;   object-fit: cover;  margin-right: 10px;height:100px;margin-right: 10px;" :src="item.url"/>
            <div class="glj-upload-list-item-actions">
              <a-icon @click="preView(item.url)" :style="{fontSize: '24px',color:'#fff'}" type="eye" />
              <a-icon @click="delImg(item,'2')" :style="{color:'#fff',fontSize:'24px',marginLeft: '10px'}" type="delete" />
            </div>
          </div>
          <div class="plus_div" @click="addImgList('2')" v-if="thisShopList.length<8">
            <a-icon :style="{ fontSize: '24px',color:'#999999' }" type="plus" />
          </div>

        </div>
        <!-- <upload-file-list-cmp sk-type="2" :f-list="thisShopList" class="file-upload" type="image" @fileListUrlFn="fileListUrlFn"></upload-file-list-cmp> -->
      </div>
    </div>

    <div class="imgInfro">内部环境</div>
    <div class="ImgBP">
      <div class="item_img">
        <div class="editimg"></div>
        <div class="imgList_cmp">
          <div class="img_content glj-upload-list-item-info" v-for="(item,index) in interiorList" :key="index" >
            <img style="width: 100px;   margin-top: 10px;  object-fit: cover;  margin-right: 10px;height:100px;margin-right: 10px;" :src="item.url"/>
            <div class="glj-upload-list-item-actions">
              <a-icon @click="preView(item.url)" :style="{fontSize: '24px',color:'#fff'}" type="eye" />
              <a-icon @click="delImg(item,'3')" :style="{color:'#fff',fontSize:'24px',marginLeft: '10px'}" type="delete" />
            </div>
          </div>
          <div class="plus_div" @click="addImgList('3')" v-if="interiorList.length<8">
            <a-icon :style="{ fontSize: '24px',color:'#999999' }" type="plus" />
          </div>

        </div>
        <!-- <upload-file-list-cmp sk-type="3" :f-list="interiorList" class="file-upload" type="image" @fileListUrlFn="fileListUrlFn"></upload-file-list-cmp> -->
      </div>
    </div>
    <div class="imgInfro">平面图</div>
    <div class="ImgBP">
      <div class="item_img">
        <div class="editimg"></div>
        <div class="imgList_cmp">
          <div class="img_content glj-upload-list-item-info" v-for="(item,index) in planeList" :key="index" >
            <img style="width: 100px;  margin-top: 10px;   object-fit: cover;  margin-right: 10px;height:100px;margin-right: 10px;" :src="item.url"/>
            <div class="glj-upload-list-item-actions">
              <a-icon @click="preView(item.url)" :style="{fontSize: '24px',color:'#fff'}" type="eye" />
              <a-icon @click="delImg(item,'4')" :style="{color:'#fff',fontSize:'24px',marginLeft: '10px'}" type="delete" />
            </div>
          </div>
          <div class="plus_div" @click="addImgList('4')" v-if="planeList.length<8">
            <a-icon :style="{ fontSize: '24px',color:'#999999' }" type="plus" />
          </div>

        </div>
        <!-- <upload-file-list-cmp sk-type="4" :f-list="planeList" class="file-upload" type="image" @fileListUrlFn="fileListUrlFn"></upload-file-list-cmp> -->
      </div>
    </div>

    <div class="imgInfro">周边图</div>
    <div class="ImgBP">
      <div class="item_img">
        <div class="editimg"></div>
        <div class="imgList_cmp">
          <div class="img_content glj-upload-list-item-info" v-for="(item,index) in rimList" :key="index" >
            <img style="width: 100px;   margin-top: 10px;  object-fit: cover;  margin-right: 10px;height:100px;margin-right: 10px;" :src="item.url"/>
            <div class="glj-upload-list-item-actions">
              <a-icon @click="preView(item.url)" :style="{fontSize: '24px',color:'#fff'}" type="eye" />
              <a-icon @click="delImg(item,'5')" :style="{color:'#fff',fontSize:'24px',marginLeft: '10px'}" type="delete" />
            </div>
          </div>
          <div class="plus_div" @click="addImgList('5')" v-if="rimList.length<8">
            <a-icon :style="{ fontSize: '24px',color:'#999999' }" type="plus" />
          </div>

        </div>
        <!-- <upload-file-list-cmp sk-type="5" :f-list="rimList" class="file-upload" type="image" @fileListUrlFn="fileListUrlFn"></upload-file-list-cmp> -->
      </div>
    </div>
    <a-modal
      title="预览图片"
      :visible="isPreView"
      :maskClosable="false"
      :width="1050"
      centered
      :footer="null"
      @cancel="isPreView=false"
    >
      <div class="imgContent">
        <img style="width:100%" :src="preViewImg" />
      </div>
    </a-modal>
    <cropper-image
      :isHide="cropperVisible"
      :skType="skType"
      @cancelHandel="cropperVisible=false"
      @uploadImgSuccess="handleUploadSuccess"
      ref="child">
    </cropper-image>
  </div>
</template>
<script>
import UploadFileListCmp from '@/components/UploadFileListCmp/index'
import CropperImage from '@/components/CropperImage/CropperImage.vue'
export default {
  name: 'InvestigationCmp',
  props: ['type', 'fileList'],
  components: {
    UploadFileListCmp,
     CropperImage
  },
  data () {
    return {
      isPreView: false,
      preViewImg: '',

      skType: '',
      // 新增实勘-编辑图片
      addImgData: {
        accendantId: undefined, // 维护人ID，新增实勘必传
        houseId: undefined, //	id不能为空		true
        identity: this.type, //	请求类型标识（1：新增实勘:2：编辑图片）		true
        investigationImgs: {
            '1': '',
            '2': '',
            '3': '',
            '4': '',
            '5': ''
        } //	实勘图片IDs		true
      },
      img1: '',
      img2: '',
      img3: '',
      img4: '',
      img5: '',
      cropperVisible: false, // 控制裁剪弹窗
      interiorList: [], // 内部list
      planeList: [], // 平面list
      rimList: [], // 周边List
      thisShopList: [], // 本铺List
      videoList: [], // 视频List

      fileInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
    }
  },
  mounted () {},
  created () {
    this.initFileList()
  },
  methods: {

    initFileList () {
      const fileList = this.fileList
      console.log(fileList, 'fileList')
      if (fileList != null) {
        // 1视频 2本铺 3内部 4平面 5周边
        this.interiorList = this.rebuildPicList(fileList.interiorList, 3)// 内部list
        this.planeList = this.rebuildPicList(fileList.planeList, 4)// 平面list
        this.rimList = this.rebuildPicList(fileList.rimList, 5)// 周边List
        this.thisShopList = this.rebuildPicList(fileList.thisShopList, 2)// 本铺List
        this.videoList = this.rebuildPicList(fileList.videoList, 1)// 视频List
        console.log(this.planeList, 'planeList平面数据初始化')
      }
    },
    // 预览图片
    preView (img) {
      this.isPreView = true
      this.preViewImg = img
    },
      // 新增图片
    addImgList (type) {
      this.skType = type
        this.cropperVisible = true
    },
    // 删除图片
    delImg (item, type) {
      switch (type) {
        case '1':

        break
        case '2':
          const list2 = this.thisShopList.filter(map => map.uid !== item.uid)
          this.thisShopList = list2
          this.fileListUrlFn(this.thisShopList, type)
        break
        case '3':
          const list3 = this.interiorList.filter(map => map.uid !== item.uid)
          this.interiorList = list3
          this.fileListUrlFn(this.interiorList, type)
        break
        case '4':

          const list4 = this.planeList.filter(map => map.uid !== item.uid)
          this.planeList = list4
          this.fileListUrlFn(this.planeList, type)
        break
        case '5':

          const list5 = this.rimList.filter(map => map.uid !== item.uid)
          this.rimList = list5
          this.fileListUrlFn(this.rimList, type)
        break
      }
    },
    // 上传成功回调
    handleUploadSuccess (obj, type) {
      switch (type) {
        case '1':

        break
        case '2':
          this.thisShopList.push(obj)
          this.fileListUrlFn(this.thisShopList, type)
        break
        case '3':
          this.interiorList.push(obj)
          this.fileListUrlFn(this.interiorList, type)
        break
        case '4':
          this.planeList.push(obj)
          this.fileListUrlFn(this.planeList, type)

        break
        case '5':
        this.rimList.push(obj)
          this.fileListUrlFn(this.rimList, type)

        break
      }
    },

    rebuildPicList (list, type) {
      const resList = []
      let fileObj = {}
      const ossIdArr = []
      if (list != null && list.length > 0) {
        for (const item of list) {
          fileObj = {}
          fileObj.uid = item.ossId
          fileObj.name = item.fileName
          fileObj.status = 'done'
          fileObj.url = process.env.VUE_APP_OSS_URL + item.fileName
          fileObj.response = { code: 200, msg: '操作成功', data: { ossId: item.ossId } }
          resList.push(fileObj)
          ossIdArr.push(fileObj.uid)
        }
      }

      // 1视频 2本铺 3内部 4平面 5周边
      switch (type) {
        case 1:
        this.img1 = ossIdArr.join(',')
        break
        case 2:
        this.img2 = ossIdArr.join(',')
        break
        case 3:
        this.img3 = ossIdArr.join(',')
        break
        case 4:
        this.img4 = ossIdArr.join(',')
        break
        case 5:
        this.img5 = ossIdArr.join(',')
        break
      }
      this.addImgData.investigationImgs = {
          '1': this.img1,
          '2': this.img2,
          '3': this.img3,
          '4': this.img4,
          '5': this.img5
      }

      return resList
    },

    initData () {
        this.img1 = ''
        this.img2 = ''
        this.img3 = ''
        this.img4 = ''
        this.img5 = ''
    },
    fileListUrlFn (fileList, skType) {
      // console.log(fileList, skType + '===============fileList')
      // 1视频 2本铺 3内部 4平面 5周边
      if (skType === '1') {
          this.img1 = this.ossIdHandle(fileList)
          this.videoList = fileList
      } else if (skType === '2') {
          this.img2 = this.ossIdHandle(fileList)
      } else if (skType === '3') {
          this.img3 = this.ossIdHandle(fileList)
      } else if (skType === '4') {
          this.img4 = this.ossIdHandle(fileList)
      } else if (skType === '5') {
          this.img5 = this.ossIdHandle(fileList)
      }
      // console.log(this.img3, '====img3')
      this.addImgData.investigationImgs = {
          '1': this.img1,
          '2': this.img2,
          '3': this.img3,
          '4': this.img4,
          '5': this.img5
      }
      console.log(this.addImgData.investigationImgs, ' this.addImgData.investigationImgs')
      this.$emit('submitSkImg', this.addImgData.investigationImgs)
    },
    ossIdHandle (fileList) {
      const ossIdArr = []
      let ossIds = ''
      if (fileList != null && fileList.length > 0) {
        for (const f of fileList) {
          if (f && typeof (f.response) !== 'undefined') {
              ossIdArr.push(f.response.data.ossId)
              ossIds = ossIdArr.join(',')
          }
          // else if(f&&typeof(f.name)!='undefined'){
          //     ossIdArr.push(f.uid);
          //     ossIds=ossIdArr.join(",");
          // }
        }
      }
      return ossIds
    }

  }
}
</script>
<style lang="less" scoped>
.imgContent{
  width: 1000px;
  object-fit: cover;
}
.glj-upload-list-item-info{
  position: relative;
  transition: background-color 0.3s;
  &:hover {
            .glj-upload-list-item-actions {
              // display: block;
              // position: absolute;
              position: absolute;
              width: 100px;
              height: 100px;
              left: 50%;
              transform: translate(-55%, -50%);
              // line-height: 40px;
              // left: 0px;
              // top: 140px;
              // background: rgba(59, 60, 61, 0.5);
              // // box-sizing: content-box;
              // z-index: 999;
              display: flex;
              justify-content: center;
              align-items: center;
              opacity: 100;
              background:rgba(0, 0, 0, 0.6);
              // cursor: pointer;
              // text-align: right;

            }
          }
}

.glj-upload-list-item-actions{
   position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 10;
    white-space: nowrap;
    cursor: pointer;
    opacity: 0;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}
.imgList_cmp{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.img_content{
  display: flex;

  flex-wrap: wrap;
  align-items: center;
}
.plus_div{
  background-color: #fafafa;
  border: 1px   dashed  #d9d9d9;
  width: 100px;
  height: 100px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
/* .img_wrapper{
    width:100%;
    height:auto;
}
.Img {
  display: flex;
}
.item_img{
    width:32%;
    margin-left:2%;
}
.Img .item_img:nth-child(3n+1),.ImgBP .item_img:nth-child(3n+1){
    margin-left:0px;
}
.ImgBP {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.editimg {
  width:100%;
  height: 200px;
  border: 1px solid #e8e8e8;
}
.imgInfro {
    width:100%;
    height:50px;
    line-height:50px;
    font-weight: bold;
    margin:0;
} */
.trip_info{
  width:100%;
  height:auto;
  display: flex;
}
.trip_title{
  color:var(--ThemeColor);
  font-size:14px;
}
.trip_con{
   color:var(--ThemeColor);
   font-size:14px;
}
</style>
